// extracted by mini-css-extract-plugin
export default {"component":"T+0SF"};